import {Component, Vue} from 'vue-property-decorator'
import {menuBtn} from "@/utils/menu_level2_button";
import {gettHeaderByType, settHeaderByType} from "@/api/common";
import {delNullProperty} from "@/utils";
import {delOutputTemplate, getOutputTemplate} from "@/api/classManage";
import {formatDate} from "@/utils/timeFilter";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import commonData from "@/utils/commonData";

@Component({
    components: {MoreUsersFilter}
})
export default class ProduceMould extends Vue {
    // ------ 变量 ------
    buttonShow = menuBtn // 方法：按钮权限验证
    tableData = []
    checkTableList = []
    page = 1
    pageSize = 20
    total = 0
    loading = false
    outputTableHead: any[] = [] // 表头顺序列表
    draggableListChange = []
    draggableList = []
    tableHeadPopoverShow = false // 调整表头顺序的弹框是否可见
    vdaH = 0 //屏幕高度
    popHeight = 0
    timer = null
    exportButtonDisabled = false
    filterList = {
        name: '',
        souCourseTypeId: '',
        createdUserId: '',
    }
    createdAt: Date[] | null = null // 开课时间
    typeList = commonData.projectTypeArray
    delOutputDialogShow = false
    delId = ''
    createdUserId = ''

    created() {
        this.getOutputClueHeader()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260;
        this.popHeight = this.vdaH
    }

    // get userListNew() {
    //     return UserModule.userList
    // }

    // 获取表头
    async getOutputClueHeader() {
        this.loading = true
        const data: any = await gettHeaderByType(23)
        this.draggableList = data.headerUserList
        this.outputTableHead = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.getTableData()
    }

    async getTableData() {
        this.loading = true
        const obj = {
            name: this.filterList.name,
            souCourseTypeId: this.filterList.souCourseTypeId,
            createdUserId: this.filterList.createdUserId,
            page: this.page,
            limit: this.pageSize,
        }

        await getOutputTemplate(delNullProperty(obj)).then((data: any)=>{
            this.tableData = data.outputTemplateList
            this.total = data.allNum

            this.$nextTick(() => {
                if (this.$refs.multipleTable) {
                    (this.$refs.multipleTable as HTMLFormElement).doLayout();
                    (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
                }
            });
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(val: number) {
        this.pageSize = val
        this.getTableData()
    }

    // 取消调整表头
    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify(this.draggableList))
        this.tableHeadPopoverShow = false
    }

    // 改变表头顺序
    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 23})
            this.$message.success('修改表头顺序成功')
            this.getOutputClueHeader()
            this.tableHeadPopoverShow = false
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    // getExportData() {
    //     this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    //     this.exportButtonDisabled = true
    //
    //     const obj = {
    //         name: this.filterList.name,
    //
    //         souCourseTypeId: this.filterList.souCourseTypeId,
    //
    //     }
    //     exportOutputesData(delNullProperty(obj)).then(() => {
    //         this.exportButtonDisabled = false
    //     }).catch(() => {
    //         this.exportButtonDisabled = false
    //     })
    //
    // }


    handleAddOutput() {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ProduceMouldAdd', "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }


    handleViewOutput(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ProduceMouldInfo?id=' + row.id, "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

    handleEditOutput(row) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ProduceMouldAdd?id=' + row.id + '&isShow=1', "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

    handleDelOutput(row) {
        this.delId = row.id
        this.delOutputDialogShow = true
    }

    delOutputDialogConfirm() {
        delOutputTemplate(Number(this.delId)).then(res => {
            this.delOutputDialogShow = false
            this.$message.success('删除成功')
            this.getTableData()
        })
    }


    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy/MM/dd', new Date(item)) + '-'
        })
        time = time.slice(0, time.length - 1)
        return time
    }


    changeHelperUsers(e) {
        this.filterList.createdUserId = e.id
        this.createdUserId = ''
        this.pageChange(1)
    }


}
